import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../scss/Login.scss'; 

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log('handleSubmit triggered', { username, password });

    try {
      const response = await fetch(
        'https://accordi-web-eqb2byhxd0feffhu.norwayeast-01.azurewebsites.net/api/auth/login',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, password }),
        }
      );

      if (!response.ok) {
        setError('Fel användarnamn eller lösenord');
        return;
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);

      console.log('Login success', data.token);
      onLogin();

      navigate('/admin');  
    } catch (err) {
      setError('Något gick fel, försök igen.');
    }
  };
 return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Logga in</h2>
        {error && <p className="error">{error}</p>}
        <input
          type="text"
          placeholder="Användarnamn"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Lösenord"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <button type="submit">Logga in</button>
      </form>
    </div>
  );
};

export default Login;